import type { Zone } from '@seek/audience-zones';
import type { Language } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';
import React from 'react';

import Subscription from '../common/subscription';
import { getZoneUrls } from '../contactDetails';
import { trackSubscribeFailedPageLoad } from '../tracking/tealium';
import { UnsubscribeIcon } from '../unsubscribe/svg/unsubscribe-icon';

import translations from './.vocab';

const SubscribeError = ({
  language,
  zone,
  link,
  linkMessage,
}: {
  language: Language;
  zone: Zone;
  link?: string;
  linkMessage?: string;
}) => {
  const { t } = useTranslations(translations);

  trackSubscribeFailedPageLoad();

  const zoneUrls = getZoneUrls(zone, language);

  return (
    <Subscription
      title={t('error-subscription-title')}
      cardTitle={t('error-subscription-card-title')}
      body={
        <>
          {t('error-subscription-body', {
            TextLink: (children) => (
              <TextLink
                data-testid="contact-us-link"
                href={zoneUrls.contactUrl}
              >
                {children}
              </TextLink>
            ),
          })}
          <br />
          {t('error-subscription-body-line-2', {
            TextLink: (children) => (
              <TextLink
                data-testid="help-centre-link"
                href={zoneUrls.helpCentreUrl}
              >
                {children}
              </TextLink>
            ),
          })}
        </>
      }
      svg={<UnsubscribeIcon />}
      link={link}
      linkMessage={linkMessage ?? t('subscribe-subscription-link-message')}
    />
  );
};

export default SubscribeError;
